import React, { useEffect, useRef, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link, useLocation, useNavigate } from "react-router-dom";
import menuIcon from "../../assets/menu-icon.svg";
import cartBlue from "../../assets/nav-icons/cart-blue.svg";
import cartIcon from "../../assets/nav-icons/cart.svg";
import MFLogo from "../../assets/nav-icons/kfin-logo.svg";
import logoutIcon from "../../assets/nav-icons/logout.svg";
import prodBlue from "../../assets/nav-icons/production-blue.svg";
import prodIcon from "../../assets/nav-icons/production.svg";
import profileIconBlack from "../../assets/nav-icons/profile-black.svg";
import profileBlue from "../../assets/nav-icons/profile-blue.svg";
import userIcon from "../../assets/nav-icons/profile.svg";
import searchIcon from "../../assets/nav-icons/search.svg";
import wishlistIcon from '../../assets/wishlist-black.svg';
import useAuth from "../../hooks/useAuth";
import useIdleTimout from "../../hooks/useIdleTimout";
import { getDetails } from "../../services/http/http.service";
import { logoutUser } from "../../store/authentication/authentication.actions";
import { setRedirectionUrl, setShowLoginModal } from "../../store/authentication/authentication.slice";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { postPageData } from "../../store/pageData/pageData.actions";
import {
  setFilterName,
  setPageData,
  setPageNumber,
  setSearchString,
} from "../../store/pageData/pageData.slice";
import {
  setCart,
  setShowSideModal,
  setSideModalOption,
} from "../../store/selectedAPIs/selectedAPIs.slice";
import { useAppDispatch, useAppSelector } from "../../store/storeRequests";
import APIList from "../../utils/constants/APIList";
import { APIResponseCodes } from "../../utils/constants/keys.constants";
import StoreSelectors from "../../utils/constants/StoreSelectors.constants";
import { SubmitEvent } from "../../utils/constants/Types.constants";
import "./header.css";
import { NavList } from "../../utils/constants/navigation";
import { message } from "../../utils/constants/Messages";
 
const Header: React.FunctionComponent = () => {
  const searchRef = useRef(null);
  const dispatch = useAppDispatch();
  const currentUser = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const worker = useIdleTimout();
 
  const { searchString } = useAppSelector(StoreSelectors.PAGE_STATE);
  const { access } = useAppSelector(StoreSelectors.USER_STATE);
 
  const [sidebarOpened, setSidebarOpened] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [showSearchSuggestions, setShowSearchSuggestions] = useState(false);
 
  const openSidebar = () => {
    setSidebarOpened(!sidebarOpened);
  };
 
 useEffect(() => {
  // window.scrollTo(0, 0);
  if (!location.pathname.includes(NavList.MARKET_PLACE)) {
    dispatch(setSearchString(""));
  }
}, [location]);
 
 
  useEffect(() => {
    if (sidebarOpened === true) {
      document
        .getElementsByClassName("modal-static-area")[0]
        .addEventListener("click", () => {
          setSidebarOpened(false);
        });
      document.querySelector('#mfCentralBody')?.classList.add('overflow-hidden');
    } else {
      document.querySelector('#mfCentralBody')?.classList.remove('overflow-hidden');
    }
  }, [sidebarOpened]);
 
  useEffect(() => {
    document.addEventListener("mousedown", (ev) => {
      if (searchRef.current === null) return;
      const sRef: { contains: Function } = searchRef.current;
      let target: any = ev.target;
      const el = document.getElementById(target.id);
      if (typeof el === "undefined" || el === null) {
        setShowSearchSuggestions(false);
        return;
      }
      if (el.contains(target)) return;
      if (!sRef.contains(ev.target)) {
        setShowSearchSuggestions(false);
      }
    });
  }, [showSearchSuggestions]);
 
  const openLoginModal = () => {
    setSidebarOpened(false);
    dispatch(setShowLoginModal(true));
  };
 
  const onSearchChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setShowSearchSuggestions(true);
    dispatch(setSearchString(event.target.value.trimStart()));
 
    if (currentUser === 0) return;
 
    if (event.target.value.trimStart().length === 0) {
      setSearchData([]);
      return;
    }
 
    const response: any = await getDetails(
      APIList.SEARCH + "?search=" + event.target.value.trimStart(),
      () => onSearchChange(event)
    );
    if (response?.statusCode === APIResponseCodes.SUCCESS) {
      setSearchData(response.data);
      if (searchRef.current) {
        let ref: { focus: Function } = searchRef.current;
        ref.focus();
      }
      dispatch(hideLoader());
    } else {
      dispatch(hideLoader());
      console.log("Error");
    }
  };
 
  const onSearchOptionSelect = (event: any) => {
    dispatch(setSearchString(event.target.id));
    onSearchSubmit(null, event.target.id);
  };
 
  const onSearchSubmit = async (ev: SubmitEvent | null, searchValue: string) => {
    if (ev !== null) ev.preventDefault();
 
    dispatch(setFilterName("All"));
 
    if (currentUser === 0) {
      dispatch(setShowLoginModal(true));
      dispatch(setSearchString(""));
      return;
    }
 
    dispatch(setPageNumber(0));
    dispatch(showLoader(message.SEARCH_RESULT));
 
    const payload = { search: searchValue, page_no: 1 };
    const response: any = await dispatch(postPageData(APIList.GET_GROUPS, payload));
 
    if (response?.statusCode === APIResponseCodes.SUCCESS) {
      navigate(NavList.MARKET_PLACE, { state: { fromSearch: true } });
      dispatch(hideLoader());
      setSearchData([]);
    } else {
      console.log("Error");
    }
  };
 
  const handleCartClick = () => {
    if (access.hasUATAccess === false && access.hasProdAccess === false) return;
    setSidebarOpened(false);
    if (currentUser !== 0) {
      if (location.pathname.includes("/production")) {
        dispatch(setSideModalOption("prod"));
        dispatch(setCart([]));
      } else {
        dispatch(setSideModalOption("cart"));
        dispatch(setCart([]));
      }
      dispatch(setShowSideModal(true));
    }
  };
 
  const handleLogout = async () => {
    await dispatch(logoutUser());
    navigate(NavList.HOMEPAGE);
    if (worker !== null) {
      worker.postMessage('terminate');
    }
    dispatch(setRedirectionUrl(''));
  };
 
  const handleProductionLinkClick = async () => {
    if (access.hasProdAccess === false) return;
    setSidebarOpened(false);
    dispatch(setFilterName("All"));
    let response = await getDetails(APIList.GET_ALL_PROD_APIS, () => handleProductionLinkClick());
    if (response.statusCode === APIResponseCodes.SUCCESS) {
      dispatch(setPageData(response.data));
      navigate(NavList.API_LISTING_PRODUCTION);
    }
  };
 
  return (
    <header className="mf-header primary-bg-color">
      <nav className="mf-nav">
        <div className="row no-negative-margin justify-content-between align-items-center">
          <Link to={"/"} className="col-4 col-md-5 col-lg-4 px-0 no-text-decoration">
            <img src={MFLogo} alt="mf central" />
          </Link>
          <div className="cursor-pointer d-block d-md-none d-lg-none col-4 text-end px-0">
            <img
              onClick={openSidebar}
              width="70"
              height="70"
              src={menuIcon}
              alt="menu"
              className="icon-white text-end"
            />
          </div>
 
          {/* Desktop only UI */}
          <div className="col-md-7 col-lg-4 px-0 text-center text-md-end text-lg-center d-none d-md-none d-lg-block">
            <form
              className="header-search-form mx-auto position-relative"
              onSubmit={(ev) => onSearchSubmit(ev, searchString)}
            >
              <input
                ref={searchRef}
                onChange={onSearchChange}
                value={searchString}
                type="text"
                className="header-search-input bg-white border-0 font-14 weight-400 w-100"
                placeholder="Search by Name, API Category"
                maxLength={100}
              />
              <button type="submit" className="header-search-btn border-0 secondary-bg-color position-absolute">
                <img src={searchIcon} alt="search" />
              </button>
              <div className={showSearchSuggestions ? "dropdown-search custom-scrollbar" : "d-none"}>
                <ul className="mb-0">
                  {searchData.map((searchOption: any, index) => (
                    <li
                      key={index}
                      onClick={onSearchOptionSelect}
                      className="font-14 weight-400 text-capitalize search-suggestion"
                      id={searchOption.name}
                    >
                      {searchOption.name}
                    </li>
                  ))}
                </ul>
              </div>
            </form>
          </div>
 
          <div className="col-md-4 col-lg-4 px-0 d-flex align-items-center justify-content-end d-none d-md-flex d-lg-flex">
            <div
              onClick={handleCartClick}
              className={currentUser && (access.hasUATAccess || access.hasProdAccess) ? "d-flex me-4 cursor-pointer" : "d-flex me-4 opacity-05"}
            >
              <img className="me-2" width="15" height="15" src={cartIcon} alt="cart" />
              <p className="mb-0 text-capitalize text-white font-14 weight-400">cart</p>
            </div>
            <div
              onClick={handleProductionLinkClick}
              className={currentUser && access.hasProdAccess ? "d-flex me-4 align-items-center cursor-pointer" : "d-flex me-4 align-items-center opacity-05"}
            >
              <img className="me-2" width="24" height="24" src={prodIcon} alt="production" />
              <p className="mb-0 text-capitalize text-white font-14 weight-400">production</p>
            </div>
            {currentUser !== 1 && (
              <div onClick={openLoginModal} className="d-flex cursor-pointer">
                <img className="me-2" width="15" height="15" src={userIcon} alt="user" />
                <p className="mb-0 text-capitalize text-white font-14 weight-400">login</p>
              </div>
            )}
            {currentUser === 1 && (
              <div className="no-text-decoration d-flex align-items-center">
                <Dropdown align={"end"}>
                  <Dropdown.Toggle
                    id="dropdown-profile"
                    className="text-capitalize text-white font-14 weight-400 p-0 bg-none profile-dropdown-btn border-0 d-flex align-items-baseline"
                  >
                    <img className="me-2" width="15" height="15" src={userIcon} alt="user" />
                    profile
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="border-0 profile-dropdown-menu py-0">
                    <Dropdown.Item
                      onClick={() => navigate(NavList.USER_PROFILE)}
                      className="profile-dropdown-item d-flex justify-content-between"
                    >
                      <p className="mb-0 text-capitalize font-14 weight-500">profile</p>
                      <img className="me-2" width="15" height="15" src={profileIconBlack} alt="profile" />
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => navigate(NavList.WISHLIST)}
                      className="profile-dropdown-item d-flex justify-content-between"
                    >
                      <p className="mb-0 text-capitalize font-14 weight-500">wishlist</p>
                      <img className="me-2" width="15" height="15" src={wishlistIcon} alt="wishlist" />
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={handleLogout}
                      className="profile-dropdown-item d-flex justify-content-between"
                    >
                      <p className="mb-0 text-capitalize font-14 weight-500">logout</p>
                      <img className="me-2" width="15" height="15" src={logoutIcon} alt="logout" />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
          </div>
 
          <div className="col-md-12 col-lg-4 px-0 d-none d-md-block d-lg-none mt-4 mb-3">
            <form
              onSubmit={(ev) => onSearchSubmit(ev, searchString)}
              className="header-search-form position-relative"
            >
              <input
                onChange={onSearchChange}
                value={searchString}
                type="text"
                className="header-search-input bg-white border-0 font-14 weight-400 w-100"
                placeholder="Search by Name, API Category"
                maxLength={100}
              />
              <button type="submit" className="header-search-btn border-0 secondary-bg-color position-absolute">
                <img src={searchIcon} alt="search" />
              </button>
            </form>
          </div>
 
          {/* Mobile only UI */}
          {sidebarOpened && (
            <div id="mobileSidebar" className="mf-mobile-nav d-block d-md-none d-lg-none px-0">
              <div className="modal-static-area"></div>
              <div className="bg-white py-5 w-100 content-wrapper-white custom-scrollbar">
                <div className="d-flex align-items-start justify-content-start flex-column px-3 mb-3">
                  <div
                    onClick={handleCartClick}
                    className={currentUser ? "d-flex cursor-pointer" : "d-flex opacity-05"}
                  >
                    <img className="me-3" width="21" height="21" src={cartBlue} alt="cart" />
                    <p className="mb-0 text-capitalize text-primary-color weight-500">cart</p>
                  </div>
                  <div
                    onClick={handleProductionLinkClick}
                    className={currentUser && access.hasProdAccess ? "d-flex align-items-center my-4 cursor-pointer" : "d-flex align-items-center my-4 opacity-05"}
                  >
                    <img className="me-3" width="21" height="21" src={prodBlue} alt="production" />
                    <p className="mb-0 text-capitalize text-primary-color weight-500">production</p>
                  </div>
                  {!currentUser ? (
                    <div onClick={openLoginModal} className="d-flex cursor-pointer">
                      <img className="me-3" width="21" height="21" src={profileBlue} alt="user" />
                      <p className="mb-0 text-capitalize text-primary-color weight-500">login</p>
                    </div>
                  ) : <></>}
                  {currentUser ? (
                    <>
                      <div
                        onClick={() => { navigate(NavList.USER_PROFILE); setSidebarOpened(false); }}
                        className="d-flex cursor-pointer mb-4"
                      >
                        <img className="me-3" width="21" height="21" src={profileIconBlack} alt="profile" />
                        <p className="mb-0 text-capitalize text-primary-color weight-500">profile</p>
                      </div>
                      <div
                        onClick={() => { setSidebarOpened(false); navigate(NavList.WISHLIST); }}
                        className="d-flex cursor-pointer mb-4"
                      >
                        <img className="me-3" width="21" height="21" src={wishlistIcon} alt="wishlist" />
                        <p className="mb-0 text-capitalize text-primary-color weight-500">wishlist</p>
                      </div>
                      <div
                        className="d-flex cursor-pointer mb-4"
                        onClick={() => { setSidebarOpened(false); handleLogout(); }}
                      >
                        <img className="me-3" width="21" height="21" src={logoutIcon} alt="settings" />
                        <p className="mb-0 text-capitalize text-primary-color weight-500">logout</p>
                      </div>
                    </>
                  ) : <></>}
                </div>
                <div className="col-lg-4 px-0 text-center mt-4">
                  <form
                    className="header-search-form mx-auto position-relative"
                    onSubmit={(ev) => onSearchSubmit(ev, searchString)}
                  >
                    <input
                      onChange={onSearchChange}
                      value={searchString}
                      type="text"
                      className="header-search-input bg-white font-14 weight-400 w-100"
                      placeholder="Search by Name, API Category"
                      maxLength={100}
                    />
                    <button type="submit" className="header-search-btn border-0 secondary-bg-color position-absolute">
                      <img src={searchIcon} alt="search" />
                    </button>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};
 
export default Header;